<template>
  <BLayoutExpansion title="Основное" class="my-4">
    <v-row dense>
      <v-col md="8" lg="6">
        <BTextarea
          v-model="form.name"
          validate="required"
          label="Название"
          :disabled="isView"
          :skeleton="skeleton"
          rows="2"
          name="name"
          autofocus
          counter
        />
      </v-col>
    </v-row>

    <v-row dense>
      <v-col md="8" lg="6">
        <BAutocompleteCommon
          v-model="form.ate_type"
          validate="required"
          label="Тип АТЕ"
          :skeleton="skeleton"
          :disabled="isView"
          :options="ateTypes"
          :return-object="false"
          item-text="label"
          item-value="value"
          $type="select"
        />
      </v-col>
    </v-row>

    <v-row dense class="mt-4">
      <v-col md="10" lg="8" />
    </v-row>

    <v-row v-if="!isCreate" dense>
      <v-col :cols="!skeleton && 'auto'">
        <BTextField
          :value="data.created_at | dateFormatter"
          :skeleton="skeleton"
          label="Создан"
          disabled
        />
      </v-col>

      <v-col :cols="!skeleton && 'auto'">
        <BTextField
          :value="data.updated_at | dateFormatter"
          :skeleton="skeleton"
          label="Обновлен"
          disabled
        />
      </v-col>
    </v-row>

    <slot name="save-menu" />
  </BLayoutExpansion>
</template>

<script>
import BLayoutExpansion from '@/components/layouts/BLayoutExpansion.vue'
import BTextField from '@/components/forms/BTextField.vue'
import BTextarea from '@/components/forms/BTextarea.vue'
import BAutocompleteCommon from '@/components/forms/BAutocompleteCommon.vue'
import { PassportTemplateType } from '@/typings/api/Passport'

export default {
  name: 'PassportTemplatesMain',
  components: {
    BLayoutExpansion,
    BTextField,
    BTextarea,
    BAutocompleteCommon,
  },
  props: {
    skeleton: Boolean,
    disabled: Boolean,
    isCreate: Boolean,
    isView: Boolean,
    form: {
      type: Object,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    ateTypes: Object.values(PassportTemplateType).map((value) => {
      let label
      switch (value) {
        case PassportTemplateType.SCHOOL:
          label = 'ОО'
          break
        case PassportTemplateType.MUNICIPALITY:
          label = 'Муниципалитет'
          break
        case PassportTemplateType.REGION:
          label = 'Регион'
          break
        default:
          label = '---'
      }
      return { label, value }
    }),
  }),
}
</script>
